webpackJsonp([8],{

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__(778);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e6cd4a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(907)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01e6cd4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e6cd4a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e6cd4a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(687)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-565437c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__ = __webpack_require__(678);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  components: {
    skSidebar: __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__["a" /* default */],
    skNavbarSidebar: __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['sidebarNavItems'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture', 'user'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('conversation', ['unreadConversations'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['token']))
});

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-sidebar'
});

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-sidebar'
});

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumb',
  props: ['items']
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(77);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__language_switcher__["a" /* default */],
    SkNavbarHeader: __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__["a" /* default */],
    NavHeaderLg: __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__["a" /* default */],
    NavHeaderMd: __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__["a" /* default */],
    NavHeaderSm: __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['headerMenuTree'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture'])),
  methods: {
    setLocale: function setLocale(locale) {
      __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].locale = locale;
      localStorage.setItem('locale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_item__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__["a" /* default */],
    NotificationItem: __WEBPACK_IMPORTED_MODULE_1__notification_item__["a" /* default */]
  },
  data: function data() {
    return {
      page: 1,
      per_page: 20
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    notifications: 'notifications/notifications',
    loading: 'notifications/loading',
    newNotifications: 'notifications/newNotifications'
  })),
  methods: {
    setSeen: function setSeen(notification) {
      if (!notification.seen_at) {
        this.$store.dispatch('notifications/seen', notification.notificationID).then(function () {
          if (notification.link) window.location.href = notification.link;
        });
      } else if (notification.link) window.location.href = notification.link;
    },
    seeAll: function seeAll() {
      var _this = this;

      this.$store.dispatch('notifications/seeAll').then(function () {
        _this.$store.dispatch('notifications/loadNotifications');

        _this.$store.dispatch('notifications/loadCounts');
      });
    },
    loadNotifications: function loadNotifications() {
      this.$store.dispatch('notifications/loadNotifications', {
        page: this.page,
        per_page: this.per_page
      });
    }
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-item',
  props: ['item'],
  computed: {
    link: function link() {
      return this.item.link || null;
    }
  },
  methods: {
    handleClick: function handleClick($event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$emit('seen', this.item);
    }
  }
});

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-header'
});

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(660);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-lg',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-md',
  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-sm',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  })),
  methods: {
    setLocale: function setLocale(locale) {
      this.$store.dispatch('language/setLocale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  name: 'page-title'
});

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__ = __webpack_require__(676);
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  components: {
    NavHeader: __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__["a" /* default */]
  }
});

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_title__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breadcrumb__ = __webpack_require__(675);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-header',
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__breadcrumb__["a" /* default */],
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__page_title__["a" /* default */]
  },
  props: ['pageTitle', 'breadcrumb']
});

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(684)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a8eb91f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('tb-skeleton',{attrs:{"aspect-ratio":1,"shape":"circle"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.1}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)])])])])}
var staticRenderFns = []


/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"col-12 col-sm-3 col-md-2 col-lg-2 position-fixed sd-bg px-sm-0 px-md-0 px-lg-1 px-xl-3 d-none d-sm-block"},[_c('div',{staticClass:"sidebar flex-nowrap overflow-auto px-0 d-flex align-items-center flex-column h-100 px-md-0 px-lg-1 px-xl-4"},[_c('div',{staticClass:"mb-auto mt-5 "},[(!_vm.user || !_vm.studentPicture)?_c('sk-sidebar'):_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"circle-border "},[_c('div',{staticClass:"circle"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":"profile-image"}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4 mb-md-5 mb-lg-0"},[_c('p',{staticClass:"f-p1 mb-2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'fullName')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'speciality')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'studentStatus')))])]),_vm._v(" "),(!_vm.sidebarNavItems || _vm.sidebarNavItems.length === 0)?_c('sk-navbar-sidebar'):_c('ul',{staticClass:"nav flex-column"},_vm._l((_vm.sidebarNavItems),function(navItem){return _c('li',{staticClass:"nav-item"},[(navItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"to":navItem.link}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()]):_c('a',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navItem.link + '&token=' + _vm.token}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()])],1)}),0)],1),_vm._v(" "),_c('div',{staticClass:" d-flex justify-content-center ug-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("635519c8", content, true, {});

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"breadcrumb.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-container  mb-3"},[_c('nav',{attrs:{"aria-label":"breadcrumb d-none d-sm-none d-md-block"}},[_c('ol',{staticClass:"breadcrumb  ml-auto "},_vm._l((_vm.items),function(item){return _c('li',{class:['breadcrumb-item', { active: item.isActive } ]},[_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1)}),0)])])}
var staticRenderFns = []


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("3cd26278", content, true, {});

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".no-notifications[data-v-565437c6]{font-weight:700;text-align:center;font-size:14px;min-height:56px}.dropdown-menu[data-v-565437c6]{padding:1.4rem 0 0;min-width:26.5rem}.dropdown-menu-items[data-v-565437c6]{max-height:300px;overflow-y:auto}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar{width:5px;height:5px}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb{background:#c2c2c2;border-radius:5px;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover{background:#c2c2c2;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track{padding-left:1rem;background:#f2f2f2;-webkit-box-shadow:inset 0 0 6px transparent;border-radius:0}", "", {"version":3,"sources":["F:/myugfront/src/components/notifications.vue"],"names":[],"mappings":"AACA,mCACE,gBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,eAAiB,CAClB,AACD,gCACE,mBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,yDACE,UAAW,AACX,UAAY,CACb,AACD,+DACE,mBAAoB,AACpB,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,qEACE,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,+DACE,kBAAmB,AACnB,mBAAoB,AACpB,6CAA8C,AAC9C,eAAiB,CAClB","file":"notifications.vue","sourcesContent":["\n.no-notifications[data-v-565437c6] {\n  font-weight: bold;\n  text-align: center;\n  font-size: 14px;\n  min-height: 56px;\n}\n.dropdown-menu[data-v-565437c6] {\n  padding: 1.4rem 0 0 0;\n  min-width: 26.5rem;\n}\n.dropdown-menu-items[data-v-565437c6] {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb {\n  background: #c2c2c2;\n  border-radius: 5px;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover {\n  background: #c2c2c2;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track {\n  padding-left: 1rem;\n  background: #f2f2f2;\n  -webkit-box-shadow: inset 0 0 6px transparent;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(690)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76d7dcc1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("5ff169c0", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown-item[data-v-76d7dcc1]{border-radius:0!important}.dropdown-item.unread[data-v-76d7dcc1],.dropdown-item[data-v-76d7dcc1]:hover{font-family:inherit!important;background-color:hsla(0,0%,75%,.1)}.dropdown-item .icon[data-v-76d7dcc1]{display:block;margin-right:1rem;padding:1rem}.dropdown-item .icon img[data-v-76d7dcc1]{width:36px}", "", {"version":3,"sources":["F:/myugfront/src/components/notification-item.vue"],"names":[],"mappings":"AACA,gCACE,yBAA4B,CAC7B,AACD,6EACE,8BAAgC,AAChC,kCAA2C,CAC5C,AACD,sCACE,cAAe,AACf,kBAAmB,AACnB,YAAc,CACf,AACD,0CACE,UAAY,CACb","file":"notification-item.vue","sourcesContent":["\n.dropdown-item[data-v-76d7dcc1] {\n  border-radius: 0 !important;\n}\n.dropdown-item[data-v-76d7dcc1]:hover, .dropdown-item.unread[data-v-76d7dcc1] {\n  font-family: inherit !important;\n  background-color: rgba(192, 192, 192, 0.1);\n}\n.dropdown-item .icon[data-v-76d7dcc1] {\n  display: block;\n  margin-right: 1rem;\n  padding: 1rem;\n}\n.dropdown-item .icon img[data-v-76d7dcc1] {\n  width: 36px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[{unread: !_vm.item.seen_at}, 'dropdown-item', 'd-flex'],attrs:{"href":_vm.link},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.item.icon}})]),_vm._v(" "),_c('div',[_c('div',{class:{'font-weight-bold': !_vm.item.seen_at},domProps:{"innerHTML":_vm._s(_vm.item.text)}}),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.helpers.getDateDifference(_vm.item.created_at)))])])])}
var staticRenderFns = []


/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown header-notify pl-4"},[_c('a',{staticClass:"nav-link position-relative cursor-pointer",attrs:{"data-toggle":"dropdown"},on:{"click":_vm.loadNotifications}},[(_vm.newNotifications > 0)?_c('span',[_c('span',{staticClass:"pulse"}),_vm._v(" "),_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notification-recieved.png","alt":"notifications"}})]):_c('span',[_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notifications.png","alt":"notifications"}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow animated"},[(_vm.loading)?_c('sk-list',{attrs:{"height":0.2,"items-count":4}}):_c('div',{staticClass:"dropdown-menu-items"},[(_vm.notifications.length === 0)?_c('div',{staticClass:"no-notifications"},[_vm._v("\n          "+_vm._s(_vm.$t('notifications.not-found'))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(notification,$index){return _c('notification-item',{key:$index,attrs:{"item":notification},on:{"seen":_vm.setSeen}})})],2),_vm._v(" "),_c('div',{staticClass:" text-center p-2 border-top"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.seeAll()}}},[_vm._v(_vm._s(_vm.$t('notifications.mark-all-as-read')))])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(697)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e7222c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("17a670c5", content, true, {});

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown:hover>.dropdown-menu[data-v-31e7222c]{display:block}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-lg.vue"],"names":[],"mappings":"AACA,gDACE,aAAe,CAChB","file":"nav-header-lg.vue","sourcesContent":["\n.dropdown:hover>.dropdown-menu[data-v-31e7222c] {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-block"},[_c('nav',{staticClass:"navbar navbar-expand-md navbar__lg  fixed-top "},[_c('div',{staticClass:"sm-w-100 d-flex order-1 order-md-2"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row align-items-center"},[_c('li',{staticClass:"nav-item d-flex align-items-center order-2 order-md-1"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item order-1 order-md-2 "},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown order-3 "},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-display":"static","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle"},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e(),_vm._v(" "),_c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse order-2 order-md-1 navbarSupportedContent",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_lg-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_lg-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")]):_c('a',{staticClass:"dropdown-item",attrs:{"href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")])],1)}),0):_vm._e()],1)}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar__md d-none d-sm-block d-md-block d-lg-none"},[_c('nav',{staticClass:"navbar fixed-top"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"}),_vm._v(" "),_c('li',{staticClass:"nav-item d-flex align-items-center"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNavmd"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex "},[_c('ul',{staticClass:"navbar-nav mb-auto "},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect && navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mb-5"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":""}})])])}]


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(703)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de3b628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("6c98affe", content, true, {});

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".navbar .nav-link[data-v-0de3b628]:focus{color:#cb2026}.flag-icon[data-v-0de3b628]{width:38px;height:38px}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-sm.vue"],"names":[],"mappings":"AACA,yCACE,aAAe,CAChB,AACD,4BACE,WAAY,AACZ,WAAa,CACd","file":"nav-header-sm.vue","sourcesContent":["\n.navbar .nav-link[data-v-0de3b628]:focus{\n  color: #cb2026;\n}\n.flag-icon[data-v-0de3b628] {\n  width: 38px;\n  height: 38px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar  d-flex align-items-center navbar__sm  fixed-top  d-block d-sm-none"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNav"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex justify-content-end flex-column h-100 "},[_c('ul',{staticClass:"navbar-nav mb-auto "},[_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap"},[_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/geo.svg","alt":""},on:{"click":function($event){return _vm.setLocale('ka')}}}),_vm._v(" "),_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/eng.svg","alt":""},on:{"click":function($event){return _vm.setLocale('en')}}})])])],2),_vm._v(" "),_vm._m(3)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",staticStyle:{"height":"19px !important"},attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":"close button"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ug-logo mx-auto"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])}]


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-header-lg',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-md',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-sm',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-center mt-5 mt-sm-0"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []


/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(710)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e48c0c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(713)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211f040a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("d2b11102", content, true, {});

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"app-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header header top-header"},[_c('div',{staticClass:"container-fluid"},[_c('nav-header')],1)])}
var staticRenderFns = []


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("62111f00", content, true, {});

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"page-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"d-none d-sm-none d-md-block"},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{staticClass:"page-leftheader"},[_c('page-title',{attrs:{"title":_vm.pageTitle}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navbar_sidebar__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_header__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_page_page_header__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_change_password__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profile_change_information__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profile_change_picture__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profile_change_teams_password__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  components: {
    ChangeInformation: __WEBPACK_IMPORTED_MODULE_5__components_profile_change_information__["a" /* default */],
    ChangePicture: __WEBPACK_IMPORTED_MODULE_6__components_profile_change_picture__["a" /* default */],
    ChangePassword: __WEBPACK_IMPORTED_MODULE_4__components_profile_change_password__["a" /* default */],
    ChangeTeamsPassword: __WEBPACK_IMPORTED_MODULE_7__components_profile_change_teams_password__["a" /* default */],
    sidebar: __WEBPACK_IMPORTED_MODULE_1__components_navbar_sidebar__["a" /* default */],
    appHeader: __WEBPACK_IMPORTED_MODULE_2__components_app_header__["a" /* default */],
    pageHeader: __WEBPACK_IMPORTED_MODULE_3__components_page_page_header__["a" /* default */]
  },
  computed: _objectSpread({
    pageData: function pageData() {
      return {
        title: this.$t('profile.title'),
        breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: false
        }, {
          icon: '',
          title: this.$t('profile.title'),
          link: '/profile',
          isActive: true
        }]
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])('auth', ['studentPicture', 'user']))
});

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-password',
  data: function data() {
    return {
      form: this.emptyForm(),
      errors: []
    };
  },
  methods: {
    emptyForm: function emptyForm() {
      return {
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      };
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/profile/change-password', this.form).then(function (response) {
        _this.helpers.notifySuccessMessage(_this.$t('profile.change-password.password-changed'));

        _this.form = _this.emptyForm();
      }).catch(function (error) {
        _this.helpers.notifyErrorMessage(error);

        if (error.response && error.response.data && error.response.data.message) {
          var message = error.response.data.message;
          if (message === 'validation_errors') _this.errors = error.response.data.data;
        }
      });
    }
  }
});

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__skeletons_sk_profile_contact_info__ = __webpack_require__(919);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-information',
  components: {
    SkProfileContactInfo: __WEBPACK_IMPORTED_MODULE_5__skeletons_sk_profile_contact_info__["a" /* default */]
  },
  data: function data() {
    return {
      form: {},
      errors: []
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    contactInfo: 'user/contactInfo'
  })),
  watch: {
    contactInfo: function contactInfo(newVal, oldVal) {
      this.form = newVal;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('user/loadContactInfo');
  },
  methods: {
    validateMobile: function validateMobile(mobile) {
      this.form.mobile = this.form.mobile.replace(/\D/g, '');
    },
    confirmMobile: function confirmMobile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _yield$_this$$swal, confirmationCode;

        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$swal({
                  input: 'text',
                  inputLabel: _this.$t('profile.change-information.confirm-mobile'),
                  confirmButtonText: _this.$t('profile.change-information.confirm')
                });

              case 2:
                _yield$_this$$swal = _context.sent;
                confirmationCode = _yield$_this$$swal.value;

                if (confirmationCode) {
                  _this.form['mobile_confirmation'] = confirmationCode;

                  _this.handleSubmit();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/contact-information', this.form).then(function (response) {
        if (response.data.data.confirm_mobile) {
          _this2.confirmMobile();
        } else {
          _this2.helpers.notifySuccessMessage(_this2.$t('profile.change-information.successfully-updated'));

          _this2.$store.dispatch('user/loadContactInfo');
        }
      }).catch(function (error) {
        _this2.helpers.notifyErrorMessage(_this2.$t('errors.general'));

        delete _this2.form.mobile_confirmation;

        if (error.response && error.response.data && error.response.data.message) {
          var message = error.response.data.message;
          if (message === 'validation_errors') _this2.errors = error.response.data.data;
        }
      });
    }
  }
});

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-profile-contact-info'
});

/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-picture',
  data: function data() {
    return {
      form: this.emptyForm(),
      uploadedPicture: null,
      errors: []
    };
  },
  mounted: function mounted() {
    this.loadUploadedPicture();
  },
  computed: {
    pictureUrl: function pictureUrl() {
      return URL.createObjectURL(this.form.picture);
    }
  },
  methods: {
    deleteUploadedPicture: function deleteUploadedPicture() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/profile/uploaded-picture').then(function (response) {
        _this.helpers.notifySuccessMessage(_this.$t('profile.change-picture.picture-deleted'));

        _this.uploadedPicture = null;
      }).catch(function (error) {
        _this.helpers.notifyErrorMessage(error);
      });
    },
    loadUploadedPicture: function loadUploadedPicture() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/profile/uploaded-picture').then(function (response) {
        if (!response.data.error) _this2.uploadedPicture = "data:image/jpeg;base64,".concat(response.data);
      });
    },
    emptyForm: function emptyForm() {
      return {
        picture: null
      };
    },
    onFileInputChange: function onFileInputChange() {
      delete this.errors.picture;
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      var formData = new FormData();
      formData.append('picture', this.form.picture);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/profile/change-picture', formData).then(function (response) {
        _this3.helpers.notifySuccessMessage(_this3.$t('profile.change-picture.wait-for-confirmation'));

        _this3.loadUploadedPicture();
      }).catch(function (error) {
        _this3.helpers.notifyErrorMessage(error);
      }).finally(function () {
        _this3.form = _this3.emptyForm();
      });
    }
  }
});

/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-teams-password',
  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    changeTeamsPassword: function changeTeamsPassword() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/profile/change-teams-password').then(function (response) {
        var data = response.data.data;

        _this.helpers.notifySuccessMessage(_this.$t('profile.change-teams-password.password-changed', {
          email: data.email,
          password: data.password
        }));
      }).catch(function (error) {
        _this.helpers.notifyErrorMessage(error);
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$swal({
        title: this.$t('profile.change-teams-password.confirmation'),
        showCancelButton: true,
        confirmButtonText: this.$t('profile.change-teams-password.ok'),
        cancelButtonText: this.$t('profile.change-teams-password.cancel'),
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.isConfirmed) {
          _this2.changeTeamsPassword();
        }
      });
    }
  }
});

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(908);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("03f4d9e3", content, true, {});

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"profile.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_password_vue__ = __webpack_require__(779);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0136e62d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_password_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(910)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0136e62d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0136e62d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_password_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0136e62d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_password_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(911);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("14b805b0", content, true, {});

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"change-password.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-header mb-4"},[_c('span',[_vm._v(_vm._s(_vm.$t('profile.change-password.title')))])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-9"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row row-sm text-left"},[_c('div',{staticClass:"col-12"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-password.current-password'),"label-for":"current_password"}},[_c('b-form-input',{staticClass:"form-control",class:_vm.errors.current_password ? 'is-invalid' : '',attrs:{"id":"current_password","type":"password","placeholder":_vm.$t('profile.change-password.current-password'),"required":""},on:{"focus":function($event){delete _vm.errors.current_password}},model:{value:(_vm.form.current_password),callback:function ($$v) {_vm.$set(_vm.form, "current_password", $$v)},expression:"form.current_password"}}),_vm._v(" "),(_vm.errors.current_password)?_c('div',_vm._l((_vm.errors.current_password),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1),_vm._v(" "),_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-password.new-password'),"label-for":"new_password"}},[_c('b-form-input',{class:_vm.errors.new_password ? 'is-invalid' : '',attrs:{"id":"new_password","type":"password","placeholder":_vm.$t('profile.change-password.new-password'),"required":""},on:{"focus":function($event){delete _vm.errors.new_password}},model:{value:(_vm.form.new_password),callback:function ($$v) {_vm.$set(_vm.form, "new_password", $$v)},expression:"form.new_password"}}),_vm._v(" "),(_vm.errors.new_password)?_c('div',_vm._l((_vm.errors.new_password),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1),_vm._v(" "),_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-password.new-password-confirmation'),"label-for":"new_password_confirmation"}},[_c('b-form-input',{class:_vm.errors.new_password_confirmation ? 'is-invalid' : '',attrs:{"id":"new_password_confirmation","type":"password","placeholder":_vm.$t('profile.change-password.new-password-confirmation'),"required":""},on:{"focus":function($event){delete _vm.errors.new_password_confirmation}},model:{value:(_vm.form.new_password_confirmation),callback:function ($$v) {_vm.$set(_vm.form, "new_password_confirmation", $$v)},expression:"form.new_password_confirmation"}}),_vm._v(" "),(_vm.errors.new_password_confirmation)?_c('div',_vm._l((_vm.errors.new_password_confirmation),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1),_vm._v(" "),_c('b-form-group',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary-red-10",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('profile.change-password.change')))])])],1)])])])])])])}
var staticRenderFns = []


/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_information_vue__ = __webpack_require__(780);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c66b28_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_information_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(914)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74c66b28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c66b28_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_information_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c66b28_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_information_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(915);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("2942f60e", content, true, {});

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"change-information.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 916:
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(918);


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_profile_contact_info_vue__ = __webpack_require__(781);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4210787d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_profile_contact_info_vue__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_profile_contact_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4210787d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_profile_contact_info_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4210787d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_profile_contact_info_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4 mt-5 mb-5"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-header mb-4"},[_c('span',[_vm._v(_vm._s(_vm.$t('profile.change-information.title')))])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-9"},[(!_vm.helpers.isEmptyObject(_vm.contactInfo))?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row row-sm"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-information.mobile'),"label-for":"mobile"}},[_c('b-form-input',{class:_vm.errors.mobile ? 'is-invalid' : '',attrs:{"id":"mobile","type":"text","required":""},on:{"change":function($event){return _vm.validateMobile($event)},"focus":function($event){delete _vm.errors.mobile}},model:{value:(_vm.form.mobile),callback:function ($$v) {_vm.$set(_vm.form, "mobile", $$v)},expression:"form.mobile"}}),_vm._v(" "),(_vm.errors.mobile)?_c('div',_vm._l((_vm.errors.mobile),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-information.phone'),"label-for":"phone"}},[_c('b-form-input',{class:_vm.errors.phone ? 'is-invalid' : '',attrs:{"id":"phone","type":"text"},on:{"focus":function($event){delete _vm.errors.phone}},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}),_vm._v(" "),(_vm.errors.phone)?_c('div',_vm._l((_vm.errors.phone),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-information.email'),"label-for":"email"}},[_c('b-form-input',{class:_vm.errors.email ? 'is-invalid' : '',attrs:{"id":"email","type":"email","required":""},on:{"focus":function($event){delete _vm.errors.email}},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_vm._v(" "),(_vm.errors.email)?_c('div',_vm._l((_vm.errors.email),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-information.ug_email'),"label-for":"ug_email"}},[_c('b-form-input',{attrs:{"type":"text","disabled":"","value":_vm.form.email_ug}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-information.address'),"label-for":"address"}},[_c('b-form-input',{class:_vm.errors.address ? 'is-invalid' : '',attrs:{"id":"address","type":"text","required":""},on:{"focus":function($event){delete _vm.errors.address}},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}}),_vm._v(" "),(_vm.errors.address)?_c('div',_vm._l((_vm.errors.address),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-information.address_temp'),"label-for":"address_temp"}},[_c('b-form-input',{class:_vm.errors.address_temp ? 'is-invalid' : '',attrs:{"id":"address_temp","type":"text"},on:{"focus":function($event){delete _vm.errors.address_temp}},model:{value:(_vm.form.address_temp),callback:function ($$v) {_vm.$set(_vm.form, "address_temp", $$v)},expression:"form.address_temp"}}),_vm._v(" "),(_vm.errors.address_temp)?_c('div',_vm._l((_vm.errors.address_temp),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-4 mt-4"},[_c('b-form-group',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary-red-10",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('profile.change-information.save')))])])],1)])]):_c('sk-profile-contact-info',{staticClass:"w-100"})],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_picture_vue__ = __webpack_require__(782);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353bc22a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_picture_vue__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(923)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-353bc22a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_picture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353bc22a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_picture_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353bc22a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_picture_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(924);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("3d8dfb70", content, true, {});

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".max-picture[data-v-353bc22a]{max-height:8.5rem}", "", {"version":3,"sources":["F:/myugfront/src/components/profile/change-picture.vue"],"names":[],"mappings":"AACA,8BACE,iBAAmB,CACpB","file":"change-picture.vue","sourcesContent":["\n.max-picture[data-v-353bc22a]{\n  max-height: 8.5rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-header mb-4"},[_c('span',[_vm._v(_vm._s(_vm.$t('profile.change-picture.title')))])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-9"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row row-sm"},[_c('div',{staticClass:"col-12 mt-3 mb-4"},[(_vm.uploadedPicture)?_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.uploadedPicture}})]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('p',{staticClass:"text-dark f-p2"},[_vm._v(_vm._s(_vm.$t('profile.change-picture.wait-for-confirmation')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary-red-7",on:{"click":_vm.deleteUploadedPicture}},[_vm._v("\n                    "+_vm._s(_vm.$t('profile.change-picture.delete'))+"\n                  ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 col-lg-12 offset-md-2 offset-lg-0 mb-3"},[_c('b-form-group',{staticClass:"f-p2",attrs:{"label":_vm.$t('profile.change-picture.choose-picture'),"label-for":"picture"}},[_c('b-form-file',{attrs:{"placeholder":_vm.$t('profile.change-picture.choose-picture'),"drop-placeholder":_vm.$t('profile.change-picture.choose-picture')},on:{"change":_vm.onFileInputChange},model:{value:(_vm.form.picture),callback:function ($$v) {_vm.$set(_vm.form, "picture", $$v)},expression:"form.picture"}}),_vm._v(" "),(_vm.errors.picture)?_c('div',_vm._l((_vm.errors.picture),function(error){return _c('span',{staticClass:"d-block is-invalid"},[_vm._v(_vm._s(error))])}),0):_vm._e()],1),_vm._v(" "),(_vm.form.picture)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"img-fluid max-picture",attrs:{"src":_vm.pictureUrl}})]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('button',{staticClass:"btn btn-primary-red-7 mb-2 mt-3",on:{"click":function($event){_vm.form.picture = null}}},[_vm._v("\n                    "+_vm._s(_vm.$t('profile.change-picture.delete'))+"\n                  ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center mt-4"},[_c('button',{staticClass:"btn btn-primary-red-10 mx-auto",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('profile.change-picture.change')))])])],1)])])])])])])}
var staticRenderFns = []


/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_teams_password_vue__ = __webpack_require__(783);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a92859_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_teams_password_vue__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(927)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43a92859"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_teams_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a92859_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_teams_password_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a92859_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_teams_password_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(928);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("d29f4224", content, true, {});

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"change-teams-password.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4 mt-3"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-9"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row row-sm text-left"},[_c('div',{staticClass:"col-12 text-center"},[_c('button',{staticClass:"btn btn-primary-red-10",attrs:{"disabled":_vm.loading,"type":"submit"}},[_vm._v(_vm._s(_vm.$t('profile.change-teams-password.change')))])])])])])])])])}
var staticRenderFns = []


/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('main',{staticClass:"col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10",attrs:{"role":"main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-5"},[_c('app-header'),_vm._v(" "),_c('p',{staticClass:"f-p2 text-center",staticStyle:{"font-size":"20px","color":"red"}},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'studentStatus')))]),_vm._v(" "),_c('page-header',{attrs:{"page-title":_vm.pageData.title,"breadcrumb":_vm.pageData.breadcrumb}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mx-md-5 px-md-5"},[_c('div',{staticClass:"col-md-12 col-lg-6 mb-5 mb-lg-0"},[_c('change-password')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6"},[_c('change-picture'),_vm._v(" "),_c('change-teams-password')],1)]),_vm._v(" "),_c('div',{staticClass:"row mx-md-5 px-md-5"},[_c('div',{staticClass:"col-12"},[_c('change-information')],1)])])],1)])}
var staticRenderFns = []


/***/ })

});


// WEBPACK FOOTER //
// static/js/8.3b4c122258fce4411c51.js